var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useState } from 'react';
import { useBoolState } from '@/hooks/state/useBoolState';
/**
 * promiseのローディング自動更新つきの実行
 */
export const usePromiseDoingCallback = (args) => {
    const { beforeCallbackFunc, finallyCallbackFunc, initialDoingState, promiseEvent, skipAsyncExecution, unmountRef, } = args;
    const { boolState: doing, changeFalse: changeNotDoing, changeTrue: changeDoing, } = useBoolState({
        initialState: initialDoingState || false,
    });
    // 短い間隔で何度もpromiseEventが実行された時、一瞬doingがtrueに切り替わってしまうのを防ぐためのカウンター
    const [loadingCount, changeLoadingCount] = useState(0);
    const callbackPromiseEvent = useCallback((...promiseEventArg) => __awaiter(void 0, void 0, void 0, function* () {
        if (skipAsyncExecution) {
            return;
        }
        changeLoadingCount((prevCount) => prevCount + 1);
        changeDoing();
        beforeCallbackFunc === null || beforeCallbackFunc === void 0 ? void 0 : beforeCallbackFunc(...promiseEventArg);
        try {
            yield promiseEvent(...promiseEventArg);
        }
        finally {
            if (!unmountRef.current) {
                changeNotDoing();
                changeLoadingCount((prevCount) => prevCount - 1);
                finallyCallbackFunc === null || finallyCallbackFunc === void 0 ? void 0 : finallyCallbackFunc(...promiseEventArg);
            }
        }
    }), [
        beforeCallbackFunc,
        changeDoing,
        changeNotDoing,
        finallyCallbackFunc,
        promiseEvent,
        skipAsyncExecution,
        unmountRef,
    ]);
    return {
        callbackPromiseEvent,
        changeDoing,
        // 実行中の非同期処理が1件でもある場合、ローディング中とみなす
        doing: loadingCount > 0 || doing,
    };
};
